import { useOrgId } from '../../../../../hooks/useOrg';
import { useRequest } from 'ahooks';
import workspaceDetailService from '../../../../../services/workspaceDetailService';
import { useEffect, useMemo } from 'react';
import { Form, Radio, Select } from 'antd';
import { PartialSKU } from '../../../../../domains/skuDomain';
import { useAppDispatch } from '../../../../../app/hooks';

type SpecifySuppliersProps = {
  sku?: PartialSKU;
  isMulti?: boolean;
  cb?: (v: any) => void;
  radioChangeCb?: () => void;
};
export const SpecifySuppliers = ({
  sku,
  cb,
  radioChangeCb,
}: SpecifySuppliersProps) => {
  const orgId = useOrgId();
  const { data: orgList } = useRequest(
    workspaceDetailService.getSimpleOrgList,
    {
      defaultParams: [orgId],
    }
  );
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const newSku = {
      ...sku,
      ...{
        specifySupplierOrgIds: sku?.specifySupplierOrgIds || [],
        isSpecifySupplier: sku?.isSpecifySupplier ?? false,
      },
    };
    form.setFieldsValue(newSku);
  }, [sku, form]);

  const supplierOptions = useMemo(() => {
    return orgList?.map((item) => ({
      label: item.name,
      value: item.id,
    }));
  }, [orgList]);
  return (
    <Form
      form={form}
      onValuesChange={async (v, allV) => {
        dispatch.sku.showSkuLoading();
        await cb?.(allV);
        dispatch.sku.hideSkuLoading();
      }}
    >
      <Form.Item name="isSpecifySupplier">
        <Radio.Group onChange={radioChangeCb}>
          <Radio value={false}>Include all suppliers in the network</Radio>
          <Radio value={true}>Use indicated suppliers</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item noStyle dependencies={['isSpecifySupplier']}>
        {({ getFieldValue }) =>
          getFieldValue('isSpecifySupplier') && (
            <div className="specify-supplier">
              <Form.Item name="specifySupplierOrgIds">
                <Select
                  options={supplierOptions}
                  mode="multiple"
                  showSearch
                  filterOption={(i, o) => {
                    return (o?.label as string)
                      ?.toLowerCase()
                      .includes(i.toLowerCase());
                  }}
                />
              </Form.Item>
            </div>
          )
        }
      </Form.Item>
    </Form>
  );
};

export const SpecifySuppliersFlag = ({
  sku,
  isMulti,
}: SpecifySuppliersProps) => {
  const multiText = isMulti ? '(Update in multi-SKU)' : '';
  return (
    <>
      {!!sku?.specifySuppliers?.length ? (
        <div>
          Use presses for: {sku?.specifySuppliers.map((i) => i.name).join(', ')}{' '}
          {multiText}
        </div>
      ) : (
        <div>Use presses for: all suppliers in the network {multiText}</div>
      )}
    </>
  );
};
